import StarIcon from "@mui/icons-material/Star";
import { Button } from "@mui/material";
import { useEffect } from "react";
import { DRAWER_VIEW } from "@/constants/views";
import { ratingSummary, webReviewsEnabled } from "@/lib/orderingUi";
import { useAppDispatch, useAppSelector } from "@/store";
import { openDrawer } from "@/store/slices/commonSlice";
import { loadRatings } from "@/store/slices/ratingsSlice";

export default function StoreRating() {
  const dispatch = useAppDispatch();
  const settings = useAppSelector(s => s.settings.data);
  const ratings = useAppSelector(s => s.ratings);
  const enabled = webReviewsEnabled(settings.enabled_review_platforms);
  useEffect(() => { if (enabled && settings._id) void dispatch(loadRatings(settings._id)); }, [dispatch, enabled, settings._id]);
  if (!enabled) return null;
  const { count, average } = ratingSummary(ratings.tenantId === settings._id ? ratings.data : []);
  return <Button size="small" startIcon={<StarIcon sx={{ color: "warning.main" }} />}
    aria-label={count ? `Reviews: ${average.toFixed(1)} out of 5 from ${count} reviews` : "Reviews: no reviews yet"}
    onClick={() => dispatch(openDrawer(DRAWER_VIEW.REVIEWS))}
    sx={{ minWidth: 0, px: 0.5, py: 0, minHeight: 22, fontSize: 11, textTransform: "none", whiteSpace: "nowrap" }}>
    {count ? `${average.toFixed(1)} (${count})` : ratings.loading ? "Loading reviews…" : "No reviews yet"}
  </Button>;
}
